import { CardEventName } from "../../contexts/ProductCardEventContext/productCardEvents";

export const listEvents = {
  ready: "product-list:ready",
  empty: "product-list:empty",
  warning: "product-list:warning",
  error: "product-list:error",
} as const;

export type ListEventName = (typeof listEvents)[keyof typeof listEvents];

export type ProductListEventName = CardEventName | ListEventName;
